module.exports = __webpack_public_path__ + "img/img24.1dffa88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img24.jpg
// module id = 369
// module chunks = 0